import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, HtmlContent } from './ui';

const StyledFeaturedLogos = styled.section`
  ${sectionMargins('45px', '90px')};
  text-align: center;
`;

const StyledHeader = styled.header`
  max-width: 880px;
  text-align: center;
  margin: 0 auto;
`;

const StyledText = styled(HtmlContent)`
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 40px;
  `}
`;

const StyledLogos = styled.div`
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-items: center;
  gap: 30px;
  justify-content: center;

  ${minBreakpointQuery.tsmall`
    gap: 40px;
  `}

  ${minBreakpointQuery.small`
    margin-top: 60px;
    gap: 50px;
  `}

  ${minBreakpointQuery.smedium`
    gap: 60px;
  `}

  ${minBreakpointQuery.medium`
    margin-top: 70px;
    gap: 70px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 80px;
    gap: 80px;
  `}

  ${minBreakpointQuery.xlarge`
    gap: 90px;
  `}
`;

const StyledLogo = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  max-width: 165px;
  max-height: 40px;
`;

const FeaturedLogos = ({ heading, text, items }) => (
  <StyledFeaturedLogos>
    <Container>
      <StyledHeader>
        <Heading>{heading}</Heading>
        <StyledText content={text} />
      </StyledHeader>
      <StyledLogos>
        {items.map((item, id) => (
          <StyledLogo
            key={id}
            {...(item.format === 'svg'
              ? {
                  as: 'img',
                  src: item.url,
                  loading: 'lazy',
                }
              : {
                  image: item.gatsbyImageData,
                  objectFit: 'contain',
                })}
            alt={item.alt}
          />
        ))}
      </StyledLogos>
    </Container>
  </StyledFeaturedLogos>
);

export default FeaturedLogos;
